import { DateFormat } from '../const/date-formatter/date-formatter.const'
import moment from 'moment'

export class EventModel {
  id: string
  organiserId: string
  name: string
  description: string
  fromDateTime: any
  toDateTime: any
  deadlineDateTime: any
  city: string
  address: string
  maxNumberOfAttendees: number
  numberOfAttendees: number
  money: number
  cabbage: number
  salt: number
  isApproved: boolean
  reasonOfDelete: string
  imageUrl?: string
  imageStoragePath?: string
  isRegistered?: boolean

  constructor(params?: {
    id: string
    organiserId: string
    name: string
    description: string
    fromDateTime: Date
    toDateTime: Date
    deadlineDateTime: Date
    city: string
    address: string
    maxNumberOfAttendees: number
    numberOfAttendees: number
    money: number
    cabbage: number
    salt: number
    isApproved: boolean
    reasonOfDelete: string
    imageUrl?: string
    imageStoragePath?: string
    isRegistered?: boolean
  }) {
    if (params) {
      this.id = params.id != null ? params.id : null
      this.organiserId = params.organiserId != null ? params.organiserId : null
      this.name = params.name != null ? params.name : null
      this.description = params.description != null ? params.description : null
      this.fromDateTime = params.fromDateTime != null ? formatDateSafe(params.fromDateTime) : null
      this.toDateTime = params.toDateTime != null ? formatDateSafe(params.toDateTime) : null
      this.deadlineDateTime = params.deadlineDateTime != null ? formatDateSafe(params.deadlineDateTime) : null
      this.city = params.city != null ? params.city : null
      this.address = params.address != null ? params.address : null
      this.maxNumberOfAttendees = params.maxNumberOfAttendees != null ? params.maxNumberOfAttendees : null
      this.numberOfAttendees = params.numberOfAttendees != null ? params.numberOfAttendees : 0
      this.money = params.money != null ? params.money : 0
      this.cabbage = params.cabbage != null ? params.cabbage : 0
      this.salt = params.salt != null ? params.salt : 0
      this.isApproved = params.isApproved != null ? params.isApproved : false
      this.reasonOfDelete = params.reasonOfDelete != null ? params.reasonOfDelete : null
      this.imageUrl = params.imageUrl != null ? params.imageUrl : null
      this.imageStoragePath = params.imageStoragePath != null ? params.imageStoragePath : null
      this.isRegistered = params.isRegistered != null ? params.isRegistered : false
    }
  }
}

export class EventModelDto {
  name: string
  description: string
  fromDateTime: any
  toDateTime: any
  deadlineDateTime: any
  city: string
  address: string
  maxNumberOfAttendees: number
  numberOfAttendees: number
  organiserId: string
  money: number
  cabbage: number
  salt: number
  isApproved: boolean
  imageUrl?: string
  imageStoragePath?: string

  constructor(params?: {
    name: string
    description: string
    fromDateTime: Date
    toDateTime: Date
    deadlineDateTime: Date
    city: string
    address: string
    maxNumberOfAttendees: number
    numberOfAttendees: number
    organiserId: string
    money: number
    cabbage: number
    salt: number
    isApproved: boolean
    imageUrl?: string
    imageStoragePath?: string
  }) {
    if (params) {
      this.name = params.name != null ? params.name : null
      this.description = params.description != null ? params.description : null
      this.fromDateTime = params.fromDateTime != null ? formatDateSafe(params.fromDateTime) : null
      this.toDateTime = params.toDateTime != null ? formatDateSafe(params.toDateTime) : null
      this.deadlineDateTime = params.deadlineDateTime != null ? formatDateSafe(params.deadlineDateTime) : null
      this.city = params.city != null ? params.city : null
      this.address = params.address != null ? params.address : null
      this.maxNumberOfAttendees = params.maxNumberOfAttendees != null ? params.maxNumberOfAttendees : null
      this.numberOfAttendees = params.numberOfAttendees != null ? params.numberOfAttendees : 0
      this.organiserId = params.organiserId != null ? params.organiserId : null
      this.money = params.money != null ? params.money : 0
      this.cabbage = params.cabbage != null ? params.cabbage : 0
      this.salt = params.salt != null ? params.salt : 0
      this.isApproved = params.isApproved != null ? params.isApproved : false
      this.imageUrl = params.imageUrl != null ? params.imageUrl : null
      this.imageStoragePath = params.imageStoragePath != null ? params.imageStoragePath : null
    }
  }
}

const DATE_INPUT_FORMATS = [DateFormat.DEFAULT, 'YYYY.MM.DD. HH:mm', moment.ISO_8601]

function formatDateSafe(value: any): string {
  const parsed = moment(value, DATE_INPUT_FORMATS as any, true)
  if (parsed.isValid()) {
    return parsed.format(DateFormat.DEFAULT)
  }
  const fallback = moment(value)
  return fallback.isValid() ? fallback.format(DateFormat.DEFAULT) : null
}

export interface IEvent {
  name: string
  description: string
  fromDateTime: any
  toDateTime: any
  deadlineDateTime: any
  city: string
  address: string
  maxNumberOfAttendees: number
  organiserId: string
  money: number
  cabbage: number
  salt: number
  isApproved: boolean
  imageUrl?: string
  imageStoragePath?: string
}
